import { Space } from "@masterteam/mt-design-react";
import Attachment from "./Attachment";

const Attachments = ({ files = [], label, ...props }) => {
  if (!files?.length) return null;
  return (
    <Space direction="vertical">
      {label ? <label>{label}</label> : null}
      {files.map((file, index) => (
        <Attachment key={index} file={file} {...props} />
      ))}
    </Space>
  );
};

export default Attachments;
